import React from "react"
import { Link } from "gatsby"
import {
  Section,
  Container,
  Column,
  Columns,
  Button,
  Content,
} from "bloomer"

import Layout from "../components/layout"
import SEO from "../components/seo"
import CardIndex from "../components/card-index"
import ReadingResult from "../components/reading-result"
import data from "../data/oraculo/jogo-de-tarot/jogo-de-tarot.json"
import OutrosJogos from "../components/outros-jogos"

export default class JogoDeTarot extends React.Component {
  state = {
    selected: [],
    random:[],
    inverted:[],
  }

  
  handleClick = event => {
    let random = [...data]; // copia: no mutar el JSON compartido
    for (let i = random.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [random[i], random[j]] = [random[j], random[i]];
    }
  
    //let random = data.sort(() => .5 - Math.random())
    this.setState({random:random})
    this.setState({selected:[]})
    this.setState({inverted:[]})
  }

  render() {
    var parent = this
    const {selected, random, inverted} = this.state;

    let items =""
    // En el tarot cada carta puede salir invertida (otra interpretación + badge)
    const readingCards = selected.length === 3
      ? selected.filter(c => c && c["id"]).map((item, i) => {
          const inv = inverted[i]
          return {
            image: require("../data/oraculo/jogo-de-tarot/images/" + item["id"] + (inv ? "inv" : "") + "gde.gif"),
            title: item["title"],
            badge: inv ? "Invertida" : null,
            lines: [
              { label: "Descrição", text: item["description"] },
              { label: "Interpretação", text: inv ? item["inverted_interpretation"] : item["interpretation"] },
            ],
          }
        })
      : []
    if(random.length && selected.length<3){
      items = random.map(function(item, i){
        if(item['id']){
          const active = selected.includes(item)
          let inv = (inverted[i])? "inv":"";
          const image = require("../data/oraculo/jogo-de-tarot/images/"+item["id"]+inv+"gde.gif")
          return (
            <Button 
              key={i}
              onClick={() => {
                if(!active){
                  const selectedtmp = selected;   
                  selectedtmp.push(item);   
                  parent.setState({selected:selectedtmp})

                  const invertedtmp = inverted;   
                  invertedtmp.push(Math.random() < 0.5);   
                  parent.setState({inverted:invertedtmp})
                }                            
              }}
              className={active?'is-active column ':'column'}
            >
              <img src={image} alt={item['title']}/>
            </Button>
          )
        }else{
            return '';
        }
        
    });
    items = <Columns className="deck" isMobile isMultiline>{items}</Columns>
    }
    if(selected.length<3 && !random.length){
      items = <Button className="is-primary" onClick={() => { parent.handleClick()}}>Jogar</Button>
    }
    
 
    return (
      <Layout>
        <SEO title="Jogo de Tarot grátis: o que as cartas dizem? - EstrelaGuia" description="Jogo de Tarot grátis: mentalize a sua pergunta, tire 3 cartas e veja o que elas dizem sobre o seu momento." pathname="/jogo-de-tarot/" image="/og/jogo-de-tarot.png" />
          <Content>
            <h1>Jogo de Tarot</h1>
            {selected.length !== 3 && (
              <ol>
                <li>Mentalize a sua pergunta</li>
                <li>Clique em <strong>Jogar</strong> para embaralhar</li>
                <li>
                  Escolha 3 cartas
                  {random.length > 0 && <strong> · {selected.length}/3</strong>}
                </li>
              </ol>
            )}
          </Content>
          {selected.length === 3 ? (
            <ReadingResult
              cards={readingCards}
              positions={["Passado", "Presente", "Futuro"]}
              game="jogo-de-tarot"
              pageType="jogo-de-tarot"
              onReset={() => parent.handleClick()}
            />
          ) : (
            <Content>{items}</Content>
          )}
          <CardIndex items={data} labelField="title" base="/oraculo/tarot" heading="Significado de cada carta do Tarot" tarot={true} />
          <Content>
            <p>
              <Link to="/oraculo/tarot/">
                Ver a lista completa das 78 cartas, com arcanos maiores e menores →
              </Link>
            </p>
          </Content>
      {selected.length !== 3 && <OutrosJogos atual="/jogo-de-tarot/" />}
          </Layout>
    )
  }
}


